import { createTracker } from 'usage-tracker';
export const usageTracker = createTracker({
  standalone: true
});
export const trackView = (componentName, {
  appName,
  componentKey
}) =>
// See https://tools.hubteam.com/usage-library-ui/event-types?selectedEventType=%5BNext+Action+Components%5D+Component+View
usageTracker.track('Next Action Components', 'Component View', {
  name: componentName,
  key: componentKey,
  appName
});
export const trackUserInteraction = (componentName, action, {
  appName,
  componentKey
}) =>
// See https://tools.hubteam.com/usage-library-ui/event-types?selectedEventType=%5BNext+Action+Components%5D+User+Interaction
usageTracker.track('Next Action Components', 'User Interaction', {
  name: componentName,
  key: componentKey,
  appName,
  action
});